// HACK: React event system kind of sucks.
// We need to use this instead of the DOM `value =` operation
// in order to be able to dispatch events afterwards. :shrug:
//
// https://github.com/facebook/react/issues/10135
export default function setNativeValue(element: any, value: string) {
  const vDescriptor = Object.getOwnPropertyDescriptor(element, 'value')
  const vSetter = vDescriptor && vDescriptor.set
  const prototype = Object.getPrototypeOf(element)
  const pvDescriptor = Object.getOwnPropertyDescriptor(prototype, 'value')
  const pvSetter = pvDescriptor && pvDescriptor.set

  if (vSetter && vSetter !== pvSetter) {
    pvSetter && pvSetter.call(element, value)
  } else {
    vSetter && vSetter.call(element, value)
  }
}
